/* eslint-disable eqeqeq */
import React, { useRef, useState, useEffect, useContext } from "react";
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
  Button,
  Upload,
  message,
} from "antd";
import Api from "../../../../services/ServiceApi";
import axios from "axios";
import reqwest from "reqwest";

import moment from "moment";
import { BadgePill } from "../../../badge_pill/badge_pill";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { CallActionBtn } from "../../../../pages/uih/wf_controllers/BtnController/dynamicAction";
import { authUserContext } from "../../../../contexts";
import { StatusInfo } from "../../../utility/status_info_modal";
const { Option, OptGroup } = Select;

export default function StoptimeModal({
  CompanyId,
  OperatorId,
  ProjectId,
  modalOpen,
  setmodalOpen,
  language,
  factupdate,
  job_id,
  job_progress_id,
  job_type_id,
  Workflowdata,
  canEditend,
  wrapClassName,
  editMode = false,
  initData = null,
}) {
  const auth = useContext(authUserContext);
  const locale = auth.locale;
  const unmounted = useRef(false);
  const configurationAuth = auth.configuration;
  const editStopTimeStart =
    configurationAuth[0]?.configuration.job_full_detail.component.stoptime
      .edit_stop_stoptime;
  const enableEditButton =
    configurationAuth[0]?.configuration.job_full_detail.component.stoptime
      .enable_edit_stop_stoptime_button || false;

  const [statusSave, setstatusSave] = useState(false);
  const ToggleModal = (status) => {
    setmodalOpen(status);
  };
  const [Reason, setReason] = useState([]);
  const [progressList, setprogressList] = useState([]);
  // const [externalUrl, setexternalUrl] = useState([]);
  const [toggleEdit, settoggleEdit] = useState(editStopTimeStart ?? true);
  const [formSend, setformSend] = useState({
    start_time: "",
    total_time: "",
    service_ma_reason_id: "",
    reason: "",
    remark: "",
  });
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [LoadingText, setLoadingText] = useState("Loading");
  const [StatusMode, setStatusMode] = useState("success");
  const [Spin, setSpin] = useState(true);

  /*  checkstoptime */
  useEffect(() => {
    axios
      .all([
        Api.post("get_servicemareason", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          ma_reason: "STOPTIME",
        }),
        Api.post("master_data/job_progress_type", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_type_id: job_type_id,
          MainProcessID: null,
          SubProcessID: null,
        }),
      ])
      .then(([resServiceMa, resProgressType]) => {
        const { data: serviceReasonResult } = resServiceMa.data;
        const { data: progressType } = resProgressType.data;
        const progressTypeList = progressType?.result.map((s) => ({
          ...s,
          value: s.progress_type_id,
          label: s.progress_type_name,
        }));
        setprogressList(progressTypeList);
        setReason(serviceReasonResult.serult_service_reason);
      });
    return () => {
      unmounted.current = true;
    };
  }, [Workflowdata]);

  function handleSubmit(value) {
    setstatusSave(true);

    if (editMode) {
      // console.log("initData", initData);
      // console.log("value", value);
      Api.post("job_detail/setstoptime", {
        companyID: CompanyId,
        operatorID: OperatorId,
        projectID: ProjectId,
        jobStopID: initData?.job_stop_id,
        jobID: job_id,
        timeStart: moment(value.job_stop_start).format("DD/MM/YYYY HH:mm:ss"),
        timeEnd: value.job_stop_end
          ? moment(value.job_stop_end).format("DD/MM/YYYY HH:mm:ss")
          : null,
        userID: auth.userId,
        username: auth.username,
        remark: value.job_edit_time_remark,
      })
        .then(({ data: res }) => {
          if (res.result.code === "P") {
            setSpin(false);
            setLoadingText("Save Stop Time Success");
          } else {
            setSpin(false);
            setStatusMode("error");
            setLoadingText(`${res.result.showText}`);
          }
        })
        .catch((error) => {
          console.log("error edit", error.message);
          setSpin(false);
          setStatusMode("error");
          setLoadingText(`${error.message}`);
        });

      // console.log("value edit", value);
      // console.log("initData edit", initData);
      // setstatusSave(false);
    } else {
      if (formSend && Workflowdata) {
        Workflowdata.map((data, index) => {
          if (
            data.from_main_process_id === 3 &&
            data.next_main_action_id === 5
          ) {
            const callStoptime = CallActionBtn.stopTime(
              Workflowdata[index],
              CompanyId,
              OperatorId,
              ProjectId,
              job_id,
              job_progress_id,
              job_type_id,
              value?.progress_detail ?? 0,
              formSend.service_ma_reason_id || value.service_ma_reason_id,
              moment(value.job_stop_start).format("YYYY-MM-DD HH:mm"),
              value.job_stop_end
                ? moment(value.job_stop_end).format("YYYY-MM-DD HH:mm")
                : null,
              value.job_stop_reason,
              value.job_stop_remark
            );
            callStoptime
              .then(({ success, showText, stop_time_id }) => {
                if (success) {
                  uploadPicture(stop_time_id)
                    .then(({ success }) => {
                      if (success) {
                        setSpin(false);
                        setLoadingText("Requset Stop Time Success");
                      }
                    })
                    .catch(() => {
                      setSpin(false);
                      setStatusMode("error");
                      setLoadingText(`${showText} || Upload Image Error`);
                    });
                } else {
                  setSpin(false);
                  setStatusMode("error");
                  setLoadingText(`${showText}`);
                }
              })
              .catch(({ showText }) => {
                setSpin(false);
                setStatusMode("error");
                setLoadingText(`${showText}`);
              });
          }
        });
      } else {
        setSpin(false);
        setStatusMode("error");
        setLoadingText(`Workflow not return`);
        // notification.error({
        //   message: "Error",
        //   description: "Workflow not return",
        //   duration: 5,
        //   className: "font-thai-b fs-18",
        // });
      }
    }
  }
  function uploadPicture(job_stop_time_id) {
    return new Promise((resolve, reject) => {
      if (fileList.length > 0) {
        const images = new FormData();
        fileList
          .filter((s) => s.action === "ADD")
          .forEach((file) => {
            images.append("files", file?.originFileObj);
            images.append("job_id", job_id);
            images.append("job_progress_id", job_progress_id);
            images.append("company_id", CompanyId);
            images.append("operator_id", OperatorId);
            images.append("project_id", ProjectId);
            images.append("job_type_id", job_type_id);
            images.append("create_by", auth.username);
            images.append("pic_type", "T");
            images.append("job_reference_id", job_stop_time_id);
          });
        reqwest({
          url: `${process.env.REACT_APP_URL_API}job_detail/InsertImageListFile`,
          method: "post",
          processData: false,
          data: images,
          headers: {
            TokenUser: auth.token,
          },
          success: () => {
            fileList
              .filter((s) => s.action === "ADD")
              .forEach((file) => {
                images.delete("files", file?.originFileObj);
                images.delete("job_id", job_id);
                images.delete("job_progress_id", job_progress_id);
                images.delete("company_id", CompanyId);
                images.delete("operator_id", OperatorId);
                images.delete("project_id", ProjectId);
                images.delete("job_type_id", job_type_id);
                images.delete("create_by", auth.username);
                images.delete("pic_type", "T");
                images.delete("job_reference_id", job_stop_time_id);
              });

            setFileList(
              fileList.map((item) => ({ ...item, action: "UPDATE" }))
            );
            message.success("upload successfully.");
            resolve({ success: true });
          },
          error: () => {
            message.error("upload failed.");
            reject({ success: false });
          },
        });
      } else {
        resolve({ success: true });
      }
    });
  }
  function onOk(value) {
    console.log("onOk: ", value);
  }

  function onSelectReason(value, event) {
    setformSend((Data) => ({
      ...Data,
      reason: value,
      service_ma_reason_id: event.key,
    }));
    form.setFieldsValue({
      job_stop_remark: value + "\n",
    });
  }
  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      setFileList([...fileList, { ...info.file, action: "ADD" }]);
      console.log("info.file.originFileObj", info);
    }
  };
  // function onremarkChange(e) {
  //   setFormData((FormData) => ({ ...FormData, remark: e.target.value }));
  // }
  // function genOption() {
  //   if (progressList.length > 0) {
  //     const Optionheaderraw = progressList.filter(
  //       (data) => JSON.parse(data.data_dynamic).option_type === "group"
  //     );
  //     const Optioraw = progressList.filter(
  //       (data) => JSON.parse(data.data_dynamic).option_type === "label"
  //     );
  //     Optionheaderraw.sort(function (a, b) {
  //       return (
  //         JSON.parse(a.data_dynamic).option_seq -
  //         JSON.parse(b.data_dynamic).option_seq
  //       );
  //     });
  //     Optioraw.sort(function (a, b) {
  //       return (
  //         JSON.parse(a.data_dynamic).option_seq -
  //         JSON.parse(b.data_dynamic).option_seq
  //       );
  //     });
  //     return (
  //       <>
  //         {Optionheaderraw && Optionheaderraw.length > 0
  //           ? Optionheaderraw?.map((data, index) => (
  //               <OptGroup
  //                 label={data.label}
  //                 key={`Option_progress_index_${index}`}
  //               >
  //                 {Optioraw && Optioraw.length > 0
  //                   ? Optioraw?.map((datas, indexs) => {
  //                       if (
  //                         JSON.parse(data.data_dynamic).option_group_id ===
  //                         JSON.parse(datas.data_dynamic).option_group_id
  //                       ) {
  //                         return (
  //                           <Option
  //                             key={`progress_detail_form_progress_${
  //                               indexs + 1
  //                             }`}
  //                             value={datas.value}
  //                             data_dynamic={datas.data_dynamic}
  //                           >
  //                             <span className="default-thai-font">
  //                               {datas.label}
  //                             </span>
  //                           </Option>
  //                         );
  //                       }
  //                     })
  //                   : null}
  //               </OptGroup>
  //             ))
  //           : Optioraw && Optioraw.length > 0
  //           ? Optioraw?.map((datass, indexss) => (
  //               <option
  //                 key={`progress_detail_form_progress_${indexss + 1}`}
  //                 value={datass.value}
  //                 data_dynamic={datass.data_dynamic}
  //               >
  //                 <span className="default-thai-font">{datass.label}</span>
  //               </option>
  //             ))
  //           : null}
  //       </>
  //     );
  //   }
  // }
  // function checkSelecthasecternalUrl(value, att) {
  //   if (
  //     att.data_dynamic &&
  //     att.data_dynamic !== undefined &&
  //     att.data_dynamic !== "" &&
  //     att.data_dynamic !== "{}"
  //   ) {
  //     const rawDatadynamic = JSON.parse(att.data_dynamic);
  //     if (
  //       rawDatadynamic.external_url &&
  //       rawDatadynamic.external_url.length > 0
  //     ) {
  //       setexternalUrl(rawDatadynamic.external_url);
  //     } else {
  //       setexternalUrl([]);
  //     }
  //   }
  // }
  const statusModalCallBack = () => {
    setmodalOpen(false);
    window.location.reload();
  };
  return (
    <>
      <Modal
        title={
          <>
            <img
              src={Api.absoluteUrl(`/icon/stop_time.svg`)}
              alt={factupdate ? language[locale]["stop_time"] : "Stop Time"}
              title={factupdate ? language[locale]["stop_time"] : "Stop Time"}
            />
            <h4>{factupdate ? language[locale]["stop_time"] : "Stop Time"}</h4>
          </>
        }
        footer={null}
        visible={modalOpen}
        wrapClassName={wrapClassName}
        onCancel={() => setmodalOpen(false)}
      >
        {statusSave ? (
          <StatusInfo
            showSpinIcon={Spin}
            statusText={LoadingText}
            mode={StatusMode}
            callbackFunction={statusModalCallBack}
          ></StatusInfo>
        ) : (
          <Form
            layout="vertical"
            onFinish={handleSubmit}
            form={form}
            initialValues={
              editMode
                ? {
                    job_stop_id: initData?.job_stop_id,
                    job_stop_start: moment(initData?.job_stop_start),
                    job_stop_end: moment(initData?.job_stop_end),
                    progress_detail: initData?.progress_type_id,
                    job_stop_reason: initData?.job_stop_reason,
                    job_stop_remark: initData?.job_stop_remark,
                    service_ma_reason_id: initData?.service_ma_reason_id,
                  }
                : {
                    job_stop_start: moment(initData?.job_stop_start),
                  }
            }
          >
            <Form.Item>
              <Input.Group compact>
                <Form.Item
                  label={
                    <span className="font-thai-b c-red fs-20">
                      {factupdate
                        ? language[locale]["start_count_stop_time"]
                        : "Stop Time"}
                    </span>
                  }
                  name="job_stop_start"
                  rules={[
                    { required: true, message: "กรุณาเลือกเวลาเริ่มต้น" },
                  ]}
                >
                  <DatePicker
                    format="YYYY-MM-DD HH:mm"
                    showTime={{ format: "HH:mm" }}
                    //onChange={OnchangeStopTime}
                    // disabled={!toggleEdit}
                    onOk={onOk}
                    //defaultValue={moment()}
                  />
                </Form.Item>
                {editStopTimeStart && enableEditButton ? (
                  <Form.Item>
                    <Button
                      className="ml-2"
                      style={{ marginTop: "65%" }}
                      onClick={() => settoggleEdit(!toggleEdit)}
                    >
                      <i className="far fa-edit"></i>
                    </Button>
                  </Form.Item>
                ) : null}
              </Input.Group>
            </Form.Item>
            <Form.Item>
              <Input.Group compact>
                <Form.Item
                  label={
                    <span className="font-thai-b c-green fs-20">
                      {factupdate
                        ? language[locale]["start_count_start_time"]
                        : "Start Time"}
                    </span>
                  }
                  name="job_stop_end"
                  //rules={[{ required: true, message: "กรุณาเลือกเวลาสิ้นสุด" }]}
                >
                  <DatePicker
                    format="YYYY-MM-DD HH:mm"
                    showTime={{ format: "HH:mm" }}
                    onOk={onOk}
                    disabled={!canEditend}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            {editMode && (
              <Form.Item
                label={
                  <span className="pl-0 pr-1">หมายเหตุการแก้ไขเวลา :</span>
                }
                name="job_edit_time_remark"
                rules={[{ required: true, message: "กรุณาระบุหมายเหตุ" }]}
              >
                <Input.TextArea
                  // disabled={editMode}
                  //onChange={onremarkChange}
                  className="font-thai-r c-blue"
                  //value={FormData.remark}
                  rows={3}
                />
              </Form.Item>
            )}
            {/* {editMode ? (
              <Form.Item
                name="totaltime"
                label={
                  <span className="pl-0 pr-1">
                    {factupdate ? language[locale]["total_time"] : `Total Time`}{" "}
                    :
                  </span>
                }
              >
                <span className="">
                  {initData.total_days && initData.total_days > 0
                    ? `${initData.total_days} ${
                        factupdate ? language[locale]["days"] : `Days`
                      } `
                    : null}
                  {initData.total_hour && initData.total_hour > 0
                    ? `${initData.total_hour} ${
                        factupdate ? language[locale]["hours"] : `Hours`
                      } `
                    : null}
                  {initData.total_min && initData.total_min > 0
                    ? `${initData.total_min} ${
                        factupdate ? language[locale]["minutes"] : `Minutes`
                      } `
                    : null}
                </span>
              </Form.Item>
            ) : null} */}
            {/* <Form.Item
            name="progress_detail"
            label={
              <span className="pl-0 pr-1">
                {factupdate
                  ? language[locale]["progress_detail"]
                  : `Progress Detail`}{" "}
                :
              </span>
            }
            //rules={[{ required: true, message: "กรุณาเลือก Progress Detail" }]}
          >
            <Select
              placeholder="Select"
              onChange={checkSelecthasecternalUrl.bind(this)}
            >
              {progressList.length > 0 ? genOption() : null}
            </Select>
          </Form.Item> */}
            <Form.Item
              label={
                <span className="pl-0 pr-1">
                  {factupdate ? language[locale]["reason"] : `Reason`} :
                </span>
              }
              name="job_stop_reason"
              //rules={[{ required: true, message: "กรุณาระบุสาเหตุ" }]}
            >
              {/* <Select placeholder="โปรดระบุสาเหตุ" onChange={onSelectReason}> */}
              <Select
                placeholder="โปรดระบุสาเหตุ"
                onChange={onSelectReason}
                disabled={editMode}
              >
                {Reason.map((data) => (
                  <Option
                    key={data.service_ma_reason_id}
                    value={data.service_ma_reason_desc}
                  >
                    <span className="default-thai-font">
                      {data.service_ma_reason_desc}
                    </span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={
                <span className="pl-0 pr-1">
                  {factupdate ? language[locale]["remark"] : `Remark`} :
                </span>
              }
              name="job_stop_remark"
              rules={[{ required: true, message: "กรุณาระบุหมายเหตุ" }]}
            >
              <Input.TextArea
                disabled={editMode}
                //onChange={onremarkChange}
                className="font-thai-r c-blue"
                //value={FormData.remark}
                rows={3}
              />
            </Form.Item>
            {initData?.approve_status_id ? (
              <Form.Item name="approve_status_name">
                <div className="col-12">
                  <span className="pl-0 pr-1">
                    {factupdate ? language[locale]["approve_status"] : `Status`}{" "}
                    :
                  </span>
                  <span className="">
                    {initData?.approve_status_name ? (
                      <BadgePill
                        bgColor={initData.approve_status_bgcolor}
                        color={initData.approve_status_color}
                        text={`${initData.approve_status_name} Level: ${initData.last_approve_level_seq}`}
                      ></BadgePill>
                    ) : null}
                  </span>
                </div>
              </Form.Item>
            ) : null}
            <Form.Item label="Photo and Video" name="photoandvideo">
              <Form.Item style={{ border: "1px solid #d9d9d9", padding: 10 }}>
                <Upload
                  name="image"
                  // showUploadList={false}
                  listType="picture-card"
                  className="avatar-uploader"
                  action={`${process.env.REACT_APP_URL_API}mockupupload/`}
                  // beforeUpload={beforeUpload}
                  onChange={handleChange}
                  disabled={editMode}
                >
                  {fileList.length >= 8 ? null : (
                    <div style={{ marginTop: 8 }}>Upload</div>
                  )}
                </Upload>
              </Form.Item>
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8 }}>
              <Renderbtn
                renderBtn={{
                  visible: true,
                  html_tag: "button",
                  type: "Text",
                  text: `Close`,
                  css: "btn btn-xs btn-light",
                }}
                btnMiddleware={() => ToggleModal(false)}
                index="view_btn_closemodal"
                item={null}
                disable={false}
              ></Renderbtn>
              {/* <Button className="mr-3" onClick={() => ToggleModal(false)}>
              Close
            </Button> */}
              <Renderbtn
                renderBtn={{
                  visible: true,
                  html_tag: "button",
                  type: "Text",
                  text: `Confirm`,
                  css: "btn btn-xs btn-submit",
                }}
                btnMiddleware={() => form.submit()}
                index="view_submit_form"
                item={null}
                disable={false}
              ></Renderbtn>
              {/* <Button type="primary" htmlType="submit" disabled={statusSave}>
              Confirm
            </Button> */}
            </Form.Item>
          </Form>
        )}
      </Modal>
    </>
  );
}
